// eslint-disable-next-line import/prefer-default-export
export const currencyFormattedNumber = (currency, value) => {
  const number = Number.parseFloat(value);

  if (isNaN(number) || !currency) {
    return '';
  }

  return number.toLocaleString('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

export const formatNumber = (value, maximumFractionDigits = 2, minimumFractionDigits = 0) => {
  const number = Number.parseFloat(value);

  if (isNaN(number)) {
    return '';
  }

  return number.toLocaleString('en-US', {
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits,
  });
};

export const formatCurrencyNumber = value => {
  const number = Number.parseFloat(value);

  if (isNaN(number)) {
    return '';
  }

  if (Number.isInteger(number)) {
    return number.toLocaleString('en-US');
  }

  return number.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const integersOnly = str => str.replace(/\D/g, '');
